import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  LoadingOverlay,
  makeStyles,
} from '@knockrentals/knock-shared-web';

import { useAppContext } from '../../../Context/AppContext';
import ProductSidebar from './Components/ProductTab/ProductSidebar';
import ProductSettingsConfirmationDialog from './Components/ProductTab/ProductSettingsConfirmationDialog';
import RenterAIDataTable from './Components/ProductTab/RenterAIDataTable';
import { useProductSettingsHandlers } from './Components/ProductTab/useProductSettingsHandlers';

const useStyles = makeStyles(() => ({
  boxGrid: {
    display: 'grid',
    gap: '1%',
    gridTemplateColumns: '20% 79%',
    width: '100%',
    position: 'relative',
  },
  loadingOverlay: {
    height: '100%',
    opacity: '0.5',
    position: 'absolute',
  }
}));

const ProductEnabledSettings = ({
  companyId,
  openDownloadModal,
  productsEnabled,
  setProductsEnabled,
}) => {
  const classes = useStyles();
  const { isInternalMode } = useAppContext();

  const {
    confirmationMode,
    filteredProperties,
    filteredPropertyIds,
    handleBulkSettingsUpdate,
    handleConfirmation,
    handleConfirmationCancel,
    handleFilterProperties,
    handleProductSelect,
    handleSettingsUpdate,
    isLoading,
    products,
    selectedProduct,
    selectedProperties,
    setSelectedProperties,
  } = useProductSettingsHandlers({
    companyId,
    productsEnabled,
    setProductsEnabled,
  });

  return (
    <Box className={classes.boxGrid}>
      <ProductSidebar
        handleProductSelect={handleProductSelect}
        isInternalMode={isInternalMode}
        products={products}
        selectedProduct={selectedProduct}
      />
      <RenterAIDataTable
        filteredProperties={filteredProperties}
        filteredPropertyIds={filteredPropertyIds}
        handleBulkSettingsUpdate={handleBulkSettingsUpdate}
        handleFilterProperties={handleFilterProperties}
        handleSettingsUpdate={handleSettingsUpdate}
        isInternalMode={isInternalMode}
        properties={productsEnabled}
        selectedProduct={selectedProduct}
        selectedProperties={selectedProperties}
        setSelectedProperties={setSelectedProperties}
      />
      <ProductSettingsConfirmationDialog
        confirmationMode={confirmationMode}
        handleCancel={handleConfirmationCancel}
        handleConfirmation={handleConfirmation}
        openDownloadModal={openDownloadModal}
      />
      <LoadingOverlay className={classes.loadingOverlay} open={isLoading} />
    </Box>
  );
};

ProductEnabledSettings.propTypes = {
  companyId: PropTypes.number.isRequired,
  openDownloadModal: PropTypes.func.isRequired,
  productsEnabled: PropTypes.arrayOf(
    PropTypes.shape({
      aiEmailEnabled: PropTypes.string,
      emailProductEnabled: PropTypes.string,
      genAiEmailEnabled: PropTypes.string,
      leasingEnabled: PropTypes.bool,
      propertyId: PropTypes.number.isRequired,
      propertyName: PropTypes.string.isRequired,
      residentEnabled: PropTypes.bool,
      tableData: PropTypes.shape({
        id: PropTypes.number,
      }),
    }),
  ),
  setProductsEnabled: PropTypes.func.isRequired,
};

export default ProductEnabledSettings;
